<template>
  <base-module-modal
      :added-modules="allDesiredModules"
      :hidden-modules="hiddenModules"
      :unavailable-modules="requiredModules"
      :modal-name="this.$options.name"
      @confirm-operation="updateDesiredModules"
      icon-modal="stars"
      modal-title="Manage desired modules"
      text-hint="If you cannot find a module, search for 'Special topic' (for Mathematics) or 'Module' (for other
      Sciences) and select a module of the fitting area with the right credit amount."
      unavailable-reason="required"
  >
  </base-module-modal>
</template>

<script>

import BaseModuleModal from "@/components/modals/BaseModuleModal.vue";
import {getAbsoluteSemester, getSemesterDifference} from "../../utils.js";
import {mapGetters, mapState} from "vuex";

export default {
  name: "DesiredModulesModal",
  components: {BaseModuleModal},
  computed: {
    ...mapState(["preferences","nextSemesters", "program"]),
    ...mapGetters(["requiredModules", "desiredModules"]),
    hiddenModules() {
     // do not offer passed modules and modules who are not offered in the next semesters or whose frequency is 0
          const hidden = [...this.$store.state.preferences.passedModules];

          const startSemester = this.preferences.startSemester;
          const maxSemester = this.program.maxPeriodOfStudy + 1;

          const semesters = [];
          for (let i = 0; i <= maxSemester; i++) {
            const semester = getAbsoluteSemester(i + 1, startSemester); 
            semesters.push(semester);
          }

          const referenceSemester = this.preferences.currentSemester || this.$store.state.config?.currentSemester || this.preferences.startSemester;

          this.program.modules.forEach(module => {
            const occurrence = this.program.moduleOccurrences[module.id];
            const offeredSemesters = this.program.offeredSemesters[module.id] || [];
            const isValid = (module.validFrom == null || getSemesterDifference(referenceSemester, module.validFrom) >= 0) &&
                                (module.validTo == null || getSemesterDifference(referenceSemester, module.validTo) <= 0);
            const isOfferedInAnySemester = offeredSemesters.some(offeredSemester => 
              semesters.includes(offeredSemester) 
            );
          
            if ((!isOfferedInAnySemester && !occurrence && !hidden.includes(module.id)) || !isValid) {
              hidden.push(module.id);
            }
      });
      return hidden;

    }, allDesiredModules() {
        return  this.preferences.desiredModules.concat(
          Object.keys(this.preferences.desiredInSemModules))  
      }
  },
  methods: {
    updateDesiredModules(markedModules) {
      const desiredModulesToRemove = this.preferences.desiredModules.filter(module => !markedModules.includes(module))
      const desiredInSemModulesToRemove = Object.keys(this.preferences.desiredInSemModules).filter(module => !markedModules.includes(module))
      const modulesToAdd = markedModules.filter(module => !this.preferences.desiredModules.includes(module))

      desiredModulesToRemove.forEach(module => {
        this.$store.commit("REMOVE_DESIRED_MODULE", {desiredModule:module,bulk : true});
      })
      desiredInSemModulesToRemove.forEach(module => {
        this.$store.commit("REMOVE_DESIRED_IN_SEM_MODULE", {desiredInSemModule:module, bulk : true});
      })
      modulesToAdd.forEach(module => {
        this.$store.commit("ADD_DESIRED_MODULE", {desiredModule : module, bulk : true});
      })
      this.$store.commit('SAVE_STATE');
    }
  },
};
</script>

